<template>
  <v-dialog v-model="show" max-width="800px" :persistent="persistent">
    <v-card>
      <slot name="title">
        <v-card-title v-if="textExists(title)" style="justify-content: center">
          {{ title }}
        </v-card-title>
      </slot>
      <slot name="text">
        <v-card-text v-if="textExists(text)">
          {{ text }}
        </v-card-text>
      </slot>
      <slot name="content"></slot>
      <v-card-actions class="pa-0">
        <v-btn color="primary" tile class="ml-0" style="width: 50%" @click="validate()">
          {{ $t('subOrder.validate') }}
        </v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { textExists } from '../../helpers/helper'

  export default {
    name: 'YesNoDialog',
    props: {
      title: {
        type: String,
        default: undefined,
      },
      text: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      closeOnValidate: {
        type: Boolean,
        default: true,
      },
      persistent: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      validate: function () {
        this.$emit('validate')
        if (this.closeOnValidate) {
          this.show = false
        }
      },
      close: function () {
        this.$emit('close')
        this.show = false
      },
      textExists,
    },
  }
</script>
<style scoped></style>
